import { useState, useMemo } from "react";
import { ModalComponent } from "../../components";
import restService from "../../../restService";
import moment from "moment";
import { PulseLoader } from "react-spinners";
import { handleRewardTypes } from "../../../utilities";
import { transactionsState } from "../../../redux/entriesSlice";

import { useSelector } from "react-redux";

const EntriesTable = ({
  loading,
  campaign,
  user,
  setMsisdn,
  setPage,
  containsStation,
}) => {
  const transactions = useSelector(transactionsState);

  const [showModal, setShowModal] = useState(false);
  const [entryDetails, setEntryDetails] = useState(null);
  const [wantToBlock, setWantToBlock] = useState(false);
  const [wantToUnBlock, setWantToUnBlock] = useState(false);
  const [success, setSuccess] = useState(false);
  const [successfulBlock, setSuccessfulBlock] = useState(false);
  const [successfulUnBlock, setSuccessfulUnBlock] = useState(false);
  const [successfulSuspend, setSuccessfulSuspend] = useState(false);
  const [successfulUnSuspend, setSuccessfulUnSuspend] = useState(false);
  const [wantToSuspend, setWantToSuspend] = useState(false);
  const [wantToUnSuspend, setWantToUnSuspend] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [totalNumberOfEntries, setTotalNumberOfEntries] = useState("");
  const [loadingDetails, setLoadingDetails] = useState(false);
  const [totalWins, setTotalWins] = useState(0);

  const handleClose = () => {
    setWantToBlock(false);
    setWantToUnBlock(false);
    setWantToSuspend(false);
    setWantToUnSuspend(false);
    setSuccessfulUnSuspend(false);
    setSuccess(false);
    setIsLoading(false);
    setEntryDetails({});
    setTotalNumberOfEntries("");
    setShowModal(false);
  };

  const findTotalNumberOfEntries = async () => {
    try {
      const empty = "";

      const {
        data: { status, data, totalCount, numberOfPages, currentPage, limit },
      } = await restService.Entries.getFilteredEntries(
        campaign.id,
        0,
        10000000,
        entryDetails.msisdn,
        empty,
        empty,
        empty,
        empty,
        empty,
        empty,
        empty,

        user.accessToken
      );

      setTotalNumberOfEntries(totalCount);
    } catch (error) {
      console.log(error);
    }
  };

  const getTotalWins = async (msisdn, lol) => {
    const empty = "";

    try {
      const { data } = await restService.Entries.getFilteredEntries(
        campaign.id,
        0,
        10000000,
        msisdn.replace(/ /g, ""),
        empty,
        empty,
        empty,
        lol,
        empty,
        empty,
        empty,
        user.accessToken
      );

      console.log(data);
    } catch (error) {
      console.log(error);
    }
  };

  // useMemo(() => {
  //   entryDetails && findTotalNumberOfEntries();
  // }, [entryDetails && entryDetails.msisdn]);

  const handleBlockEntrant = async () => {
    setIsLoading(true);

    try {
      const data = await restService.Entries.blockEntrant(
        campaign.id,
        entryDetails.msisdn,
        user.accessToken
      );

      setWantToBlock(false);
      setWantToSuspend(false);
      setSuccessfulSuspend(false);
      setSuccessfulUnBlock(false);
      setSuccess(true);
      setSuccessfulBlock(true);
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setSuccess(false);
      setIsLoading(false);
      handleClose();
    }
  };
  const handleUnBlockEntrant = async () => {
    setIsLoading(true);

    try {
      const data = await restService.Entries.unBlockEntrant(
        campaign.id,
        entryDetails.msisdn,
        user.accessToken
      );

      setWantToBlock(false);
      setWantToUnBlock(false);
      setSuccessfulSuspend(false);
      setSuccessfulBlock(false);
      setWantToSuspend(false);
      setSuccess(true);
      setSuccessfulUnBlock(true);
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setSuccess(false);
      setIsLoading(false);
      handleClose();
    }
  };

  const handleSuspendEntrant = async () => {
    setIsLoading(true);

    try {
      const data = await restService.Entries.suspendEntrant(
        campaign.id,
        entryDetails.msisdn,
        user.accessToken
      );

      setWantToBlock(false);
      setWantToSuspend(false);
      setSuccessfulUnBlock(false);
      setSuccessfulBlock(false);
      setSuccess(true);
      setSuccessfulSuspend(true);
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setSuccess(false);
      setIsLoading(false);
      handleClose();
    }
  };
  const handleUnSuspendEntrant = async () => {
    setIsLoading(true);

    try {
      const data = await restService.Entries.unSuspendEntrant(
        campaign.id,
        entryDetails.msisdn,
        user.accessToken
      );

      setWantToBlock(false);
      setWantToSuspend(false);
      setWantToUnSuspend(false);
      setSuccessfulUnBlock(false);
      setSuccessfulBlock(false);
      setSuccessfulSuspend(false);
      setSuccess(true);
      setSuccessfulUnSuspend(true);
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setSuccess(false);
      setIsLoading(false);
      handleClose();
    }
  };

  const handleGetUserState = async (msisdn) => {
    setLoadingDetails(true);

    try {
      const {
        data: { data },
      } = await restService.Entries.getUserState(
        campaign.id,
        msisdn,
        user.accessToken
      );

      return data;
    } catch (error) {
      console.log(error);
      return "";
    } finally {
      setLoadingDetails(false);
    }
  };

  const handleGetUserPoints = async (msisdn) => {
    setLoadingDetails(true);

    try {
      const {
        data: { data },
      } = await restService.PointsSystem.getUserPoints(
        campaign.id,
        msisdn,
        user.accessToken
      );

      console.log({ data });
      return data;
    } catch (error) {
      console.log(error);
      return "";
    } finally {
      setLoadingDetails(false);
    }
  };

  return (
    <>
      <table className="w-full  bg-white border-b-lg shadow ">
        <thead className="bg-[#F4F4F4] rounded py-2">
          <tr>
            <th className="text-left px-6 py-5 md:text-sm text-xs font-normal">
              Date
            </th>
            {containsStation && (
              <th className="text-left px-6 py-5 md:text-sm text-xs font-normal">
                Outlet
              </th>
            )}

            <th className="text-left px-6 py-5 md:text-sm text-xs font-normal ">
              Customer
            </th>
            <th className="text-left px-6 py-5 md:text-sm text-xs font-normal ">
              Channel
            </th>
            <th className="text-left px-6 py-5 md:text-sm text-xs font-normal ">
              Code
            </th>
            <th className="text-left px-6 py-5 md:text-sm text-xs font-normal ">
              SKU
            </th>
            <th className="text-left px-6 py-5 md:text-sm text-xs font-normal ">
              Result
            </th>
            <th className="text-left px-6 py-5 md:text-sm text-xs font-normal ">
              Status
            </th>
            <th className="text-left px-6 py-5 md:text-sm text-xs font-normal">
              {" "}
              Reward
            </th>
          </tr>
        </thead>

        <tbody className="text-[#848484]">
          {loading && (
            <tr className="w-full">
              <td className="text-center" colSpan="8">
                <div className="my-8 w-full mx-auto">
                  <PulseLoader color="#FF6A3A" />
                </div>
              </td>
            </tr>
          )}

          {transactions?.length === 0 && !loading && (
            <tr className="w-full">
              <td className="text-center" colSpan="5">
                <div className="my-8 mx-auto">
                  <img
                    src={require("../../../assets/images/noData.svg")}
                    alt=""
                    className="mx-auto"
                  />
                  {/* <img
                    className="mx-auto"
                    width="200"
                    height="200"
                    src={require("../../../assets/images/noData.svg")}
                  /> */}
                </div>
              </td>
            </tr>
          )}
          {transactions?.length > 0 &&
            transactions?.map((value, index, array) => (
              <tr
                key={index}
                className="hover:bg-[#F4F4F4] hover:cursor-pointer focus:bg-[#F4F4F4] focus:cursor-pointer "
                // onClick={async () => {
                //   setShowModal(true);
                //   // getTotalWins(value.msisdn, value.status);
                //   setEntryDetails({
                //     ...value,
                //     userState: await handleGetUserState(value?.msisdn),
                //     walletPoints: await handleGetUserPoints(value?.msisdn),
                //   });
                // }}
              >
                <td className="px-6 text-left whitespace-nowrap  text-xs md:text-sm py-6">
                  {moment(new Date(value?.created)).format(
                    "DD/MM/YYYY, h:mm:ss A"
                  )}
                </td>

                {containsStation && (
                  <td className="px-6 whitespace-nowrap  text-xs md:text-sm py-6 text-left capitalize">
                    {value?.station}
                  </td>
                )}

                <td className="px-6 whitespace-nowrap  text-xs md:text-sm py-6 text-left">
                  {value?.msisdn}
                </td>
                <td className="px-6 whitespace-nowrap  text-xs md:text-sm py-6 text-left">
                  {value?.channel}
                </td>
                <td className="px-6 whitespace-nowrap  text-xs md:text-sm py-6 text-left">
                  {value?.code}
                </td>
                <td className="px-6 whitespace-nowrap  text-xs md:text-sm py-6 text-left">
                  {value?.sku}
                </td>
                <td className="px-6 whitespace-nowrap  text-xs md:text-sm py-6 px-auto">
                  {value?.transaction_result}
                </td>
                <td className=" whitespace-nowrap  text-xs md:text-sm  text-left">
                  {value.status == "REDEEMED" ? (
                    <button className="bg-green-100 text-green-600  text-xs md:text-sm capitalize px-4 py-1.5 rounded-lg hover:font-bold">
                      {value?.status?.toLowerCase()}
                    </button>
                  ) : value.status == "FAIL" ? (
                    <button className="bg-red-100  text-xs md:text-sm text-red-600 capitalize  px-8 py-1.5 rounded-lg hover:font-bold">
                      {value?.status?.toLowerCase()}
                    </button>
                  ) : value.status == "PENDING" ? (
                    <button className="bg-yellow-100  text-xs md:text-sm text-yellow-600 capitalize px-4 py-1.5 rounded-lg hover:font-bold">
                      {value?.status?.toLowerCase()}
                    </button>
                  ) : (
                    <button className="bg-[#3989DD1a]  text-xs md:text-sm text-[#3989DD] capitalize px-4 py-1.5 rounded-lg hover:font-bold">
                      {value?.status?.toLowerCase()?.replace("_", " ")}
                    </button>
                  )}
                </td>
                <td className=" text-left whitespace-nowrap px-6 text-xs md:text-sm py-6 ">
                  {handleRewardTypes(
                    value?.rewardType?.replace("_", " "),
                    value?.amount
                  )}
                </td>
              </tr>
            ))}
        </tbody>
      </table>

      <ModalComponent
        showModal={showModal}
        width={"max-w-3xl"}
        setShowModal={setShowModal}
        handleClose={handleClose}
      >
        <div className="flex items-center flex-col w-full justify-center gap-9 py-[37px]">
          {loadingDetails ? (
            <PulseLoader color="#FF6A3A" />
          ) : (
            <>
              {" "}
              {entryDetails && (
                <>
                  {!wantToBlock &&
                    !wantToUnBlock &&
                    !wantToSuspend &&
                    !wantToUnSuspend &&
                    !success && (
                      <>
                        <h3 className="font-[700] text-[20px] text-[#24211D]">
                          Entry Details
                        </h3>

                        <div className="flex flex-col gap-5 w-full">
                          <div className="flex item-center justify-between w-full gap-11 ">
                            <div className="flex-1 flex items-center justify-end w-full">
                              <p className="text-base font-[400] text-[#848484]">
                                Customer:{" "}
                              </p>
                            </div>
                            <div className="flex flex-1 items-center justify-start w-full">
                              <p className="text-base text-[#24211D] font-[700]">
                                {entryDetails.msisdn}
                              </p>
                            </div>
                          </div>

                          <div className="flex item-center justify-between w-full gap-11">
                            {" "}
                            <div className="flex-1 flex items-center justify-end w-full">
                              <p className="text-base font-[400] text-[#848484]">
                                Transaction Date:{" "}
                              </p>
                            </div>
                            <div className="flex flex-1 items-center justify-start w-full">
                              <p className="text-base text-[#24211D] font-[700]">
                                {moment(
                                  new Date(entryDetails?.created?.millis)
                                ).format("DD/MM/YYYY, h:mm:ss A")}
                              </p>
                            </div>
                          </div>

                          <div className="flex item-center justify-between gap-11">
                            {" "}
                            <div className="flex flex-1 items-center justify-end w-full">
                              <p className="text-base font-[400] text-[#848484]">
                                Status:{" "}
                              </p>
                            </div>
                            <div className="flex flex-1 items-center justify-start w-full">
                              <p className=" whitespace-nowrap  text-xs md:text-sm  text-left">
                                {entryDetails?.status == "REDEEMED" ? (
                                  <button className="bg-green-100 text-green-600  text-xs md:text-sm capitalize px-4 py-1.5 rounded-lg hover:font-bold">
                                    {entryDetails?.status?.toLowerCase()}
                                  </button>
                                ) : entryDetails?.status == "FAIL" ? (
                                  <button className="bg-red-100  text-xs md:text-sm text-red-600 capitalize  px-8 py-1.5 rounded-lg hover:font-bold">
                                    {entryDetails?.status?.toLowerCase()}
                                  </button>
                                ) : entryDetails?.status == "PENDING" ? (
                                  <button className="bg-yellow-100  text-xs md:text-sm text-yellow-600 capitalize px-4 py-1.5 rounded-lg hover:font-bold">
                                    {entryDetails?.status?.toLowerCase()}
                                  </button>
                                ) : (
                                  <button className="bg-[#3989DD1a]  text-xs md:text-sm text-[#3989DD] capitalize px-4 py-1.5 rounded-lg hover:font-bold">
                                    {entryDetails?.status
                                      ?.toLowerCase()
                                      ?.replace("_", " ")}
                                  </button>
                                )}
                              </p>
                            </div>
                          </div>

                          <div className="flex item-center justify-between gap-11">
                            <div className="flex flex-1 items-center justify-end w-full">
                              <p className="text-base font-[400] text-[#848484]">
                                Reward:{" "}
                              </p>
                            </div>

                            <div className="flex flex-1 items-center justify-start w-full">
                              <p className="text-base text-[#24211D] font-[700] capitalize">
                                {entryDetails?.rewardType &&
                                  entryDetails?.rewardType?.toLowerCase()}
                              </p>
                            </div>
                          </div>

                          {/* <div className="flex item-center justify-between gap-11">
                            <div className="flex flex-1 items-center justify-end w-full">
                              <p className="text-base font-[400] text-[#848484]">
                                Wins:{" "}
                              </p>
                            </div>
                            <div className="flex flex-1 items-center justify-start w-full">
                              <p className="text-base text-[#24211D] font-[700] capitalize">
                                {totalNumberOfEntries}
                              </p>
                            </div>
                          </div> */}

                          <div className="flex item-center justify-between gap-11">
                            <div className="flex flex-1 items-center justify-end w-full">
                              <p className="text-base font-[400] text-[#848484]">
                                Total Number of entries:{" "}
                              </p>
                            </div>
                            <div className="flex flex-1 items-center justify-start w-full">
                              <p className="text-base text-[#24211D] font-[700] capitalize">
                                {totalNumberOfEntries}
                              </p>
                            </div>
                          </div>

                          <div className="flex item-center justify-between gap-11">
                            <div className="flex flex-1 items-center justify-end w-full">
                              <p className="text-base font-[400] text-[#848484]">
                                Points Accrued:{" "}
                              </p>
                            </div>
                            <div className="flex flex-1 items-center justify-start w-full">
                              <p className="text-base text-[#24211D] font-[700] capitalize">
                                {entryDetails?.walletPoints?.loyaltyPoints}
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="flex item-center justify-between w-full gap-11 ">
                          <div className="flex flex-1 items-center justify-end w-full">
                            <p
                              onClick={() => {
                                setPage(0);
                                setMsisdn(entryDetails?.msisdn);
                                handleClose();
                              }}
                              className="text-sm cursor-pointer text-[#3989DD] font-[500]"
                            >
                              View all transactions
                            </p>
                          </div>
                          <div className="flex flex-1 items-center justify-start w-full"></div>
                        </div>

                        <div className="flex w-full items-center justify-between gap-11">
                          {entryDetails &&
                            entryDetails?.userState?.toLowerCase() !==
                              "blocked" &&
                            entryDetails?.userState?.toLowerCase() !==
                              "suspended" && (
                              <>
                                {" "}
                                <div className="flex flex-1 items-center justify-end w-full">
                                  <button
                                    onClick={() => setWantToSuspend(true)}
                                    className="bg-[#E41836] hover:bg-[#bb142d] text-white text-base font-[500] py-3 px-8 rounded"
                                  >
                                    Suspend
                                  </button>
                                </div>
                                <div className="flex flex-1 items-center justify-start w-full">
                                  <button
                                    onClick={() => setWantToBlock(true)}
                                    className="bg-[#24201D] hover:bg-[#35312e] text-white text-base font-[500] py-3 px-8 rounded"
                                  >
                                    Block Number
                                  </button>
                                </div>
                              </>
                            )}

                          {entryDetails &&
                            entryDetails?.userState?.toLowerCase() ===
                              "suspended" && (
                              <div className="flex flex-1 items-center justify-center w-full">
                                <button
                                  onClick={() => setWantToUnSuspend(true)}
                                  className="bg-[#E41836] hover:bg-[#bb142d] text-white text-base font-[500] py-3 px-8 rounded"
                                >
                                  Unsuspend
                                </button>
                              </div>
                            )}

                          {entryDetails &&
                            entryDetails?.userState?.toLowerCase() ===
                              "blocked" && (
                              <div className="flex flex-1 items-center justify-center w-full">
                                <button
                                  onClick={() => setWantToUnBlock(true)}
                                  className="bg-[#24201D] hover:bg-[#35312e] text-white text-base font-[500] py-3 px-8 rounded"
                                >
                                  Unblock Number
                                </button>
                              </div>
                            )}
                        </div>
                      </>
                    )}

                  {wantToSuspend && !success && (
                    <>
                      <h3 className="font-[700] text-[20px] text-[#24211D]">
                        Suspend Entrant
                      </h3>

                      <div className="flex flex-col gap-5 w-full">
                        <div className="flex item-center justify-between w-full gap-11 ">
                          <div className="flex-1 flex items-center justify-center w-full">
                            <p className="text-base text-center font-[400] text-[#848484]">
                              Are you sure you want to suspend this entrant?{" "}
                              <br />{" "}
                              <span className="text-base  text-[#24211D] font-[700]">
                                ({entryDetails.msisdn})
                              </span>
                            </p>
                          </div>
                        </div>
                      </div>

                      <div className="flex w-full items-center justify-between gap-11">
                        <div className="flex flex-1 items-center justify-end w-full">
                          <button
                            disabled={isLoading}
                            onClick={() => handleSuspendEntrant()}
                            className="bg-[#E41836] hover:bg-[#bb142d] text-white text-center text-base font-[500] py-3 px-8 rounded"
                          >
                            YES
                          </button>
                        </div>

                        <div className="flex flex-1 items-center justify-start w-full">
                          <button
                            onClick={() => setWantToSuspend(false)}
                            className="bg-[#24201D] hover:bg-[#35312e] text-white text-base font-[500] py-3 px-8 rounded"
                          >
                            NO
                          </button>
                        </div>
                      </div>
                    </>
                  )}
                  {wantToUnSuspend && !success && (
                    <>
                      <h3 className="font-[700] text-[20px] text-[#24211D]">
                        Unsuspend Entrant
                      </h3>

                      <div className="flex flex-col gap-5 w-full">
                        <div className="flex item-center justify-between w-full gap-11 ">
                          <div className="flex-1 flex items-center justify-center w-full">
                            <p className="text-base text-center font-[400] text-[#848484]">
                              Are you sure you want to unsuspend this entrant?{" "}
                              <br />{" "}
                              <span className="text-base  text-[#24211D] font-[700]">
                                ({entryDetails.msisdn})
                              </span>
                            </p>
                          </div>
                        </div>
                      </div>

                      <div className="flex w-full items-center justify-between gap-11">
                        <div className="flex flex-1 items-center justify-end w-full">
                          <button
                            disabled={isLoading}
                            onClick={() => handleUnSuspendEntrant()}
                            className="bg-[#E41836] hover:bg-[#bb142d] text-white text-center text-base font-[500] py-3 px-8 rounded"
                          >
                            YES
                          </button>
                        </div>

                        <div className="flex flex-1 items-center justify-start w-full">
                          <button
                            onClick={() => setWantToUnSuspend(false)}
                            className="bg-[#24201D] hover:bg-[#35312e] text-white text-base font-[500] py-3 px-8 rounded"
                          >
                            NO
                          </button>
                        </div>
                      </div>
                    </>
                  )}

                  {wantToBlock && !success && (
                    <>
                      <h3 className="font-[700] text-[20px] text-center text-[#24211D]">
                        {isLoading ? (
                          <>
                            Blocking {entryDetails.msisdn}
                            <br /> Please wait...{" "}
                          </>
                        ) : (
                          "Block Entrant"
                        )}
                      </h3>

                      <div className="flex flex-col gap-5 w-full">
                        <div className="flex item-center justify-between w-full gap-11 ">
                          <div className="flex-1 flex items-center justify-center w-full">
                            {isLoading ? (
                              <PulseLoader color="#FF6A3A" />
                            ) : (
                              <p className="text-base text-center font-[400] text-[#848484]">
                                Are you sure you want to block this entrant?{" "}
                                <br />{" "}
                                <span className="text-base  text-[#24211D] font-[700]">
                                  ({entryDetails.msisdn})
                                </span>
                              </p>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="flex w-full items-center justify-between gap-11">
                        {!isLoading && (
                          <>
                            {" "}
                            <div className="flex flex-1 items-center justify-end w-full">
                              <button
                                onClick={() => handleBlockEntrant()}
                                className="bg-[#E41836] hover:bg-[#bb142d] text-white text-center text-base font-[500] py-3 px-8 rounded"
                              >
                                YES
                              </button>
                            </div>
                            <div className="flex flex-1 items-center justify-start w-full">
                              <button
                                onClick={() => setWantToBlock(false)}
                                className="bg-[#24201D] hover:bg-[#35312e] text-white text-base font-[500] py-3 px-8 rounded"
                              >
                                NO
                              </button>
                            </div>
                          </>
                        )}
                      </div>
                    </>
                  )}
                  {wantToUnBlock && !success && (
                    <>
                      <h3 className="font-[700] text-[20px] text-center text-[#24211D]">
                        {isLoading ? (
                          <>
                            Unblocking {entryDetails.msisdn}
                            <br /> Please wait...{" "}
                          </>
                        ) : (
                          "Unblock Entrant"
                        )}
                      </h3>

                      <div className="flex flex-col gap-5 w-full">
                        <div className="flex item-center justify-between w-full gap-11 ">
                          <div className="flex-1 flex items-center justify-center w-full">
                            {isLoading ? (
                              <PulseLoader color="#FF6A3A" />
                            ) : (
                              <p className="text-base text-center font-[400] text-[#848484]">
                                Are you sure you want to unblock this entrant?{" "}
                                <br />{" "}
                                <span className="text-base  text-[#24211D] font-[700]">
                                  ({entryDetails.msisdn})
                                </span>
                              </p>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="flex w-full items-center justify-between gap-11">
                        {!isLoading && (
                          <>
                            {" "}
                            <div className="flex flex-1 items-center justify-end w-full">
                              <button
                                onClick={() => handleUnBlockEntrant()}
                                className="bg-[#E41836] hover:bg-[#bb142d] text-white text-center text-base font-[500] py-3 px-8 rounded"
                              >
                                YES
                              </button>
                            </div>
                            <div className="flex flex-1 items-center justify-start w-full">
                              <button
                                onClick={() => setWantToUnBlock(false)}
                                className="bg-[#24201D] hover:bg-[#35312e] text-white text-base font-[500] py-3 px-8 rounded"
                              >
                                NO
                              </button>
                            </div>
                          </>
                        )}
                      </div>
                    </>
                  )}

                  {success && (
                    <>
                      <h3 className="font-[700] text-[20px] text-center text-[#24211D]"></h3>

                      <div className="flex flex-col gap-5 w-full">
                        <div className="flex item-center justify-between w-full gap-11 ">
                          <div className="flex-1 flex items-center justify-center w-full">
                            <p className="text-base text-center font-[400] text-[#848484]">
                              {successfulBlock
                                ? "Successfully blocked"
                                : successfulUnBlock
                                ? "Successfully unblocked"
                                : successfulSuspend
                                ? "Successfully suspended"
                                : "Successfully unsuspended"}{" "}
                              <br />{" "}
                              <span className="text-base  text-[#24211D] font-[700]">
                                ({entryDetails.msisdn})
                              </span>
                            </p>
                          </div>
                        </div>
                      </div>

                      <div className="flex w-full items-center justify-between gap-11">
                        <div className="flex flex-1 items-center justify-center w-full">
                          <button
                            onClick={() => handleClose()}
                            className="bg-[#24201D] hover:bg-[#35312e] text-white text-base font-[500] py-3 px-8 rounded"
                          >
                            CLOSE
                          </button>
                        </div>
                      </div>
                    </>
                  )}
                </>
              )}
            </>
          )}
        </div>
      </ModalComponent>
    </>
  );
};

export default EntriesTable;
